import _ from "lodash";
import React from "react";
import { Dropdown, DropdownMenu, IconButton } from "@toddle-edu/ds-web";
import {
  ChevronRightOutlined,
  DeleteOutlined,
  TickLargeOutlined,
  EyeOutlined,
  PencilLineOutlined,
  CopyOutlined,
  DotsVerticalOutlined,
} from "@toddle-edu/ds-icons";
import useI18n from "Hooks/UseI18n";
import { useDispatch } from "Hooks/useDispatch";

import classes from "./Actions.scss";
import {
  goToMessagingV2FormRoute,
  goToMessagingV2FormTemplateRoute,
  handleDuplicateTemplate,
  handleDeleteTemplate,
} from "MessagingV2/modules/MessagingModule";
import { useChatOptions } from "MessagingV2/providers/ChatOptionsProvider";
import { FORM_TEMPLATE_TABS } from "MessagingV2/routes/FormTemplates/modules/utils";
import { isIdEqual } from "Utils";
import { getUserId } from "modules/CommonSelectors";

const TEMPLATE_ACTIONS = {
  USE_TEMPLATE: "use_template",
  PREVIEW: "preview",
  EDIT: "edit",
  DUPLICATE: "duplicate",
  DELETE: "delete",
};

const getActionTabs = ({ t, createdBy }) => {
  const creatorId = _.get(createdBy, "id");
  const isCreator = isIdEqual(creatorId, getUserId());

  return [
    {
      key: TEMPLATE_ACTIONS.USE_TEMPLATE,
      icon: <TickLargeOutlined />,
      label: t("common:use"),
    },
    {
      key: TEMPLATE_ACTIONS.PREVIEW,
      icon: <EyeOutlined />,
      label: t("common:preview"),
    },
    ...(isCreator
      ? [
          {
            key: TEMPLATE_ACTIONS.EDIT,
            icon: <PencilLineOutlined />,
            label: t("common:edit"),
          },
        ]
      : []),
    {
      key: TEMPLATE_ACTIONS.DUPLICATE,
      icon: <CopyOutlined />,
      label: t("common:duplicate"),
    },
    ...(isCreator
      ? [
          {
            key: TEMPLATE_ACTIONS.DELETE,
            icon: <DeleteOutlined />,
            isDestructive: true,
            label: t("common:delete"),
          },
        ]
      : []),
  ];
};

const Actions = props => {
  const { templateId, queryVariables, createdBy } = props;
  const dispatch = useDispatch();
  const { chatId } = useChatOptions();

  const onTabClick = ({ key }) => {
    switch (key) {
      case TEMPLATE_ACTIONS.USE_TEMPLATE:
        dispatch(
          goToMessagingV2FormRoute({
            chatId,
            templateId,
          })
        );
        break;
      case TEMPLATE_ACTIONS.PREVIEW:
        dispatch(
          goToMessagingV2FormTemplateRoute({
            chatId,
            templateId,
            tabKey: FORM_TEMPLATE_TABS.PREVIEW,
          })
        );
        break;
      case TEMPLATE_ACTIONS.EDIT:
        dispatch(
          goToMessagingV2FormTemplateRoute({
            chatId,
            templateId,
          })
        );
        break;
      case TEMPLATE_ACTIONS.DUPLICATE:
        dispatch(
          handleDuplicateTemplate({
            templateId,
            queryVariables,
          })
        );
        break;
      case TEMPLATE_ACTIONS.DELETE:
        dispatch(
          handleDeleteTemplate({
            templateId,
            queryVariables,
          })
        );

        break;
    }
  };

  const { t } = useI18n(["common"]);

  const tabs = getActionTabs({ t, createdBy });
  return (
    <div className={classes.rootContainer}>
      <Dropdown
        overlay={
          <DropdownMenu
            dsVersion="2.0"
            onClick={onTabClick}
            options={tabs}
            shouldStopPropagation={true}
          />
        }
      >
        <IconButton
          dsVersion="2.0"
          icon={<DotsVerticalOutlined />}
          variant="neural"
          type="plain"
          size="small"
          shouldStopPropagation={true}
        />
      </Dropdown>
      <IconButton
        icon={<ChevronRightOutlined />}
        variant="plain"
        size="small"
        onClick={() => {}}
      />
    </div>
  );
};

export default Actions;
